import * as rx from "rxjs";
import { Estado, Municipio, Ciudad  } from "../simple";
import { Ubicaciones } from "app/models/requireme";
import { cacheResource, bindResource, observeResource } from "kea-resource";

export const UbicacionesRx = rx.Observable
    .combineLatest(observeResource(Estado.query), observeResource(Municipio.query), observeResource(Ciudad.query))
    .map(x => ({ estado: x[0], municipio: x[1], ciudad: x[2] } as Ubicaciones));



// WEBPACK FOOTER //
// ./app/resources/items/ubicaciones.ts